import * as React from "react";
import _ from "lodash";

import { Address } from "src/library/components/Address";
import { Datetime } from "src/library/components/Datetime";
import { InfoBar } from "src/library/components/InfoBar";
import { PhoneNumber } from "src/library/components/PhoneNumber";
import { sentenceCase } from "src/library/utils/string-manipulations";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { IDrop } from "src/core/drops/api/drops.api";
import CustomerDropStatus from "src/core/customers/components/CustomerDropStatus";

interface IProps {
  isLoading: boolean;
  data: IDrop | null;
  primaryAction?: JSX.Element | null;
  secondaryAction?: JSX.Element | null;
  terminology: ITerminology;
}

const DropInfoSidebar = ({
  isLoading, data, primaryAction, secondaryAction, terminology
}: IProps) => {
  const branchInfoItems = React.useMemo(() => {
    const items = [
      {
        label: "Branch Code",
        value: data ? data.branchNumber : "-"
      },
      {
        label: "Account status",
        value: data ? <CustomerDropStatus status={data.status} /> : "-"
      },
      {
        label: `${terminology.drop.singular.text} name`,
        value: data ? data.name : "-"
      },
      {
        label: "Users",
        value: "-"
      },
      {
        label: "Address",
        value: data ? <Address address={data.address} /> : "-"
      },
      {
        label: "Created On",
        value: data ? (
          <Datetime
            date={data.createdAt}
            template="long_date"
          />
        ) : "-"
      },
      {
        label: "Contact name",
        value: data ? data.contactName : "-"
      },
      {
        label: "Contact number",
        value: data ? (
          <PhoneNumber
            phoneNumber={data.contactNumber}
            linked
          />
        ) : "-"
      },
      {
        label: "Contact email",
        value: data ? (
          <a href={`mailto: ${data.contactEmail}`}>
            {data.contactEmail}
          </a>
        ) : "-"
      },
      {
        label: "Price code",
        value: data?.priceCode?.name || "-"
      },
      {
        label: "Site",
        value: "-"
      },
      {
        label: "Delivery route",
        value: "-"
      }
    ];

    if (data && data.customData) {
      for (const customField of data.customData) {
        items.push({
          label: customField.description,
          value: customField.value
        });
      }
    }

    return items;
  }, [ data ]);

  return (
    <InfoBar
      isLoading={isLoading}
      title={`${sentenceCase(terminology.drop.singular.text)} information`}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      items={branchInfoItems}
    />
  );
};

export default DropInfoSidebar;
